import React, { useState, useEffect } from 'react'
import { Box, Grid, Paper, Typography, Card, CardContent, Button } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import Security from '@mui/icons-material/Security'
import Assignment from '@mui/icons-material/Assignment'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import AuditRequestsListing from './AuditRequestsListing'

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  cursor: 'pointer',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  borderRadius: theme.spacing(2),
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  border: '1px solid rgba(0,0,0,0.06)',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
    borderColor: 'rgba(139, 92, 246, 0.3)',
  },
}))

const TileIconContainer = styled(Box)(({ theme }) => ({
  width: 64,
  height: 64,
  borderRadius: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(139, 92, 246, 0.1)',
  marginBottom: theme.spacing(2),
}))

export default function AuditPage() {
  const navigate = useNavigate()
  const location = useLocation()
  
  // Check if coming from therapists page
  const isFromTherapists = location.search.includes('auditorMentorIds')
  
  // If coming from therapists, automatically show audit requests (no tile selection)
  const [selectedSection, setSelectedSection] = useState(isFromTherapists ? 'audit-requests' : null)

  // If section is selected, show that section
  if (selectedSection === 'audit-requests') {
    return (
      <AuditRequestsListing 
        isFromTherapists={isFromTherapists}
        onBack={isFromTherapists ? null : () => setSelectedSection(null)}
      />
    )
  }

  return (
    <>
      <SupportHeader 
        heading="Audit Management" 
        showBackButton 
        backPath="/support-home/practitioner-management/therapists"
      />
      <Box
        sx={{
          width: '100%',
          padding: { xs: '16px', sm: '24px', md: '32px' },
          maxWidth: '1400px',
          margin: '0 auto',
        }}
      >
        <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
          Audit Management
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <StyledCard onClick={() => setSelectedSection('audit-requests')}>
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <TileIconContainer>
                  <Assignment sx={{ fontSize: 32, color: '#8b5cf6' }} />
                </TileIconContainer>
                <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}>
                  Audit Requests
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  View and manage audit access requests for chamber rooms
                </Typography>
              </CardContent>
            </StyledCard>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
